const colors = {
  primary: "#981df0",
  secondary: "#ed1c94",
  thirthiary: "#ffec17",
};

export { colors };
